import '../../../../../styles.scss';
import React, { useState } from 'react';
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { ASSET_PATH } from '../../../../consts/env.consts';
import DogRescuesPage from '../../../../pages/dog-rescues';

// eslint-disable-next-line no-undef
__webpack_public_path__ = ASSET_PATH;

const client = new ApolloClient({
    uri: '/graphql',
    cache: new InMemoryCache(),
});

const DogRescues =
    ({ dataSSR, categoriesSSR }, { pathname }) =>
    () => {
        return (
            <ApolloProvider client={client}>
                <DogRescuesPage {...{ dataSSR, categoriesSSR, pathname, useStateSSR: useState }} />
            </ApolloProvider>
        );
    };

export default DogRescues;
